import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { settingsRequest } from "../../lib/adminSettings";

function BrandRow({ brand, onSave, onDelete }) {
  const [mult, setMult] = useState(brand.multiplier);
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1 text-sm font-medium">{brand.brand}</div>
      <input
        type="number" step="0.05" min="0"
        value={mult}
        onChange={(e) => setMult(e.target.value)}
        className="w-24 bg-[#141414] border border-white/10 rounded-md px-3 py-2 text-right focus:border-[#FFC107] outline-none"
        data-testid={`brand-mult-${brand.brand}`}
      />
      <button onClick={() => onSave(brand.brand, mult)} className="btn-amber px-3 py-2 rounded-md font-semibold text-xs" data-testid={`brand-save-${brand.brand}`}>Guardar</button>
      <button onClick={() => onDelete(brand.brand)} className="text-[#EF4444] hover:bg-[#EF4444]/10 p-2 rounded-md" data-testid={`brand-delete-${brand.brand}`}>
        <Trash2 className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}

export default function BrandsSection({ brands, onChange }) {
  const [newBrand, setNewBrand] = useState("");
  const [newMult, setNewMult] = useState("1.40");
  const [saving, setSaving] = useState(false);

  const upsert = async (brand, multiplier) => {
    try {
      await settingsRequest("put", "/admin/settings/brand", { brand, multiplier: Number(multiplier) });
      toast.success(`Marca '${brand}' actualizada`);
      onChange?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };
  const remove = async (brand) => {
    if (!window.confirm(`¿Eliminar la marca "${brand}"?`)) return;
    try {
      await settingsRequest("delete", `/admin/settings/brand/${encodeURIComponent(brand)}`);
      toast.success(`Marca '${brand}' eliminada`);
      onChange?.();
    } catch { toast.error("Error al eliminar"); }
  };
  const add = async () => {
    if (!newBrand.trim()) return toast.error("Introduce el nombre de la marca");
    setSaving(true);
    await upsert(newBrand.trim(), newMult);
    setNewBrand(""); setNewMult("1.40");
    setSaving(false);
  };

  return (
    <div className="sc-card rounded-md p-6">
      <h3 className="font-display font-semibold text-lg mb-1">Marcas con recargo</h3>
      <p className="text-xs text-[#71717A] mb-5">Define el multiplicador por marca (ej: 1.40 = +40% sobre el precio base). Las marcas no listadas usan multiplicador 1.00.</p>

      <div className="space-y-2 mb-5">
        {(brands || []).length === 0 && <p className="text-sm text-[#71717A]">No hay marcas configuradas (se usan las marcas premium por defecto: BMW, Mercedes, Audi, Porsche, Tesla, Lexus, Jaguar, Land Rover con +40%).</p>}
        {(brands || []).map((b) => <BrandRow key={b.brand} brand={b} onSave={upsert} onDelete={remove} />)}
      </div>

      <div className="pt-5 border-t border-white/5">
        <div className="text-xs font-mono uppercase tracking-wider text-[#A1A1AA] mb-2">Añadir marca</div>
        <div className="flex gap-2">
          <input
            type="text"
            value={newBrand}
            onChange={(e) => setNewBrand(e.target.value)}
            placeholder="Ej: Ferrari"
            className="flex-1 bg-[#141414] border border-white/10 rounded-md px-3 py-2 text-white focus:border-[#FFC107] outline-none"
            data-testid="new-brand-name"
          />
          <input
            type="number" step="0.05" min="0"
            value={newMult}
            onChange={(e) => setNewMult(e.target.value)}
            className="w-24 bg-[#141414] border border-white/10 rounded-md px-3 py-2 text-right focus:border-[#FFC107] outline-none"
            data-testid="new-brand-mult"
          />
          <button onClick={add} disabled={saving} className="btn-amber px-4 py-2 rounded-md font-semibold text-sm flex items-center gap-1" data-testid="add-brand-btn">
            <Plus className="w-3.5 h-3.5" /> Añadir
          </button>
        </div>
      </div>
    </div>
  );
}
